export const CHAR_TAB = 9
export const CHAR_LF = 10
export const CHAR_CR = 13
export const CHAR_SPACE = 32




// WEBPACK FOOTER //
// ./src/constants/characterCodes.js